import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const curProject = () => {
  if (localStorage.getItem('current_project') !== null) {
    const projectJson = localStorage.getItem('current_project');
    const project =
      projectJson !== null
        ? JSON.parse(projectJson)
        : {
          projectId: null,
          organizationId: null,
        };
    return project;
  }
};

const initialState: any = {
  newui: {
    enabled: true,
    show: true,
    drawer: true,
  },
  users: {
    user: null,
  },
  buyer: localStorage.getItem('buyerView') !== null ? true : false,
  dashboard: false,
  currentProject: curProject,
  capabilities: [],
  suppressedArr: [],
  suppressedObj: {},
  selectiveMarketRequestSuppliers: [],
  refreshToken: false,
};

const initialStateCopy: any = JSON.parse(JSON.stringify(initialState));

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
  state: {
    newui: {
      enabled: true,
      show: true,
      drawer: true,
    },
    users: {
      user: null,
    },
    buyer: localStorage.getItem('buyerView') !== null ? true : false,
    dashboard: false,
    currentProject: curProject,
    capabilities: [],
    suppressedArr: [],
    suppressedObj: {},
    selectiveMarketRequestSuppliers: [],
    ownProjectsCount: null,
    refreshToken: false,
  },
  mutations: {
    setUser: (state: any, payload: any) => {
      state.users.user = payload;
    },
    logout: (state: any) => {
      state = Object.assign(state, initialStateCopy);
    },
    setBuyer: (state: any, payload: boolean) => {
      if (payload) {
        localStorage.setItem('buyerView', 'true');
      } else {
        localStorage.removeItem('buyerView');
      }
      state.buyer = payload;
    },
    setCurrentProject: (state: any, payload: any) => {
      localStorage.setItem('current_project', JSON.stringify(payload));
      state.currentProject = payload;
    },
    setOwnProjectsCount: (state: any, payload: any) => {
      localStorage.setItem('ownProjectsCount', payload);
      state.ownProjectsCount = payload;
    },
    setRefreshToken: (state: any, payload: boolean) => {
      state.refreshToken = payload;
    }
  },
  actions: {
    setUser: (state: any, payload: any) => {
      state.dispatch('setUser', payload);
    },
    logout: (state: any) => {
      state.dispatch('logout');
    },
    setBuyer: (state: any, payload: boolean) => {
      state.dispatch('setBuyer', payload);
    },
    setCurrentProject: (state: any, payload: any) => {
      state.dispatch('setCurrentProject', payload);
    },
    setOwnProjectsCount: (state: any, payload: any) => {
      state.dispatch('setOwnProjectsCount', payload);
    },
    setRefreshToken: (state: any, payload: boolean) => {
      state.dispatch('refreshToken', payload);
    },
  },
  getters: {
    checkUserLoadStatus: (state) => {
      return () => {
        return state.users.user !== null && state.users.user !== undefined;
      };
    },
    userLoggedIn: (state) => {
      return state.users.user !== null && state.users.user !== undefined;
    },
    currentUser: (state) => {
      return state.users.user;
    },
    currentProject: (state) => {
      return state.currentProject;
    },
    buyer: (state) => {
      return state.buyer;
    },
    ownProjectsCount: (state) => {
      return state.ownProjectsCount;
    },
    refreshToken: (state) => {
      return state.refreshToken;
    }
  },
});

